<style>
/* 搜索框动画 */
    @keyframes inputShow {
        0% {
            width: 0;
        }
        100% {
            width: 400px;
            border: 1px solid #ccc;
        }
    }
    .betweenBox{
        width: 1440px;
        margin: 0 auto;
    }
    .searBox{
        width: 477px;
        height: 30px;
       /*  margin-top: 29px; */
       /*  border: 1px solid red; */
    }
    .imgBox{
       /*  border: 1px solid red; */
        width: 20px;
        height: 20px;
        line-height: 30px;
        position: relative;
        top: 50%; /*偏移*/
        transform: translateY(-50%);
        float: right;
         cursor: pointer;
    }
    .inputDef{
        width: 0;
        height: 30px;
        border: none;
        border-radius: 20px;
    }
    .inputBian{
        float: right;
        width: 504px;
        height: 28px;
        border: none;
        animation: inputShow .5s forwards;
        border-radius: 20px;
        text-indent: 5px;
    }
    
    .searchImg1{
        width: 20px;
        height: 20px;
    }
    .searchImg2{
        width: 20px;
        height: 20px;
    }

    .inputBox{
    width:0;
    height:30px;
    background:rgba(255,255,255,1);
    box-shadow:0px 1px 6px rgba(153,152,155,0.16);
    opacity:1;
    border-radius:50px;
    float:left;
    position: relative;
    left: 80px;
    overflow: hidden;
  }
  

  .inputBox input{
    position: absolute;
    width:100%;
    height:30px;
    line-height: 30px;
    font-size:13px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(153,153,153,1);
    left:0;
    top:0;
    background: none;
    border:none;
    margin: 0 0 0 44px;
  }

  .searchImg2{
    position: absolute;
    height:20px;
    width:20px;
    top:50%;
    transform: translateY(-50%);
    left:15px;
    cursor: pointer;
  }



  .clearClick{
    width:10px;
    height:10px;
    position: absolute;
    right:12px;
    top:10px;
    cursor: pointer;
  }

  .top{
     height: 81px;
     line-height: 81px;
     display: flex;
    
     justify-content: space-between;
    /*  border: 1px solid red; */
     /* padding-right: 240px; */
     }
     .top>.right{
          height: 81px;
       /*   border: 1px solid red; */
     }
     .top>.right>div{
         float: right;
    }

   .top>.right>.baoXiaoQu>span{
      color: #575757;
      font-size: 14px;
      }
    .top>.right>.xiaoQuImg{
          margin-top: 7px;
          margin-right: 2px;
          
    }
    .top>.right>.fuZeRen>span{
      color: #575757;
      font-size: 14px;
      margin-right: 25px;
      margin-left: 6px;
      cursor: pointer;
    }
    .searBox{
        position: relative;
        top: 50%;
        transform: translateY(-50%);
    }
    .left{
      /*   height: 81px; */
     /*    border: 1px solid red; */
        display: flex;
        justify-content: space-evenly;
    }
    .left>.block{
        margin-right: 10px;
       
    }
    .left .el-cascader {
       width: 163px;
      
    }
    .left .el-input__inner{
        border-radius: 10px;
    }
    
  .down{
    width: 1440px;
    background-color: #fff;
    height: 735px;
    padding-top: 22px;
    padding-bottom: 26px;
    
  }
 
  .down>.findBox{
     /*  border: 1px solid red; */
       display: flex;
       align-items: center; 
      
       
  }
  .down>.findBox>span:nth-child(1){
    display: inline-block;
    width:2px;
    height:20px;
    background:rgba(104,81,255,1);
    opacity:1;
    margin-top: 1px;
    margin-left: 15px;
  }
  .down>.findBox>span:nth-child(2){
      display: inline-block;
      width:92px;
      height:20px;
      line-height: 20px;
      font-size:15px;
      font-family:PingFang SC;
      font-weight:500;
      line-height:21px;
      color:rgba(102,102,102,1);
      opacity:1;
      margin-left:5px;
  }
  .down>.exhibitionBox{
      display: flex;
      flex-wrap: wrap;
      margin: 0 45px;
     /*  cursor: pointer; */
   /*    border: 1px solid red; */
  }
  .down>.exhibitionBox>.xiaoQuBox{
    /*   border: 1px solid red; */
      width: 210px;
      margin-top: 26px;
      margin-right: 75px;
  }

  .down>.exhibitionBox>.xiaoQuBox>.xiaoQuImg{
   cursor: pointer;
  }
  .down>.exhibitionBox>.xiaoQuBox:nth-child(5n){
      margin-right: 0;
  }
   .down>.exhibitionBox>.xiaoQuBox>.xiaoQuName{
     /*  width:1440px;
      height:924px; */
      font-size: 18px;
      background:rgba(255,255,255,1);
      opacity:1;
      border-radius:10px;
      margin-top: 12px;
      margin-bottom: 8px;
  }
   .down>.exhibitionBox>.xiaoQuBox>.xiaoQuAddress>span{
      width:200px;
      height:22px;
      font-size:16px;
      font-family:PingFang SC;
      font-weight:500;
      line-height:22px;
      color:rgba(77,77,77,1);
      opacity:1;
  }
   .down>.exhibitionBox>.xiaoQuBox>.xiaoQuAddress{
       display: flex;
       align-items: center; 
  }

  /* 分页 css */
  
    .factoryList{
	    width:100%;
	    position: relative;
	    height: auto;
	    margin-top: 30px;
	  }
    .factoryList .factoryListNext {
	 	margin-right: 10px;
    }


</style>
<template>
    <div class="betweenBox">
        <div class="top">
    
          <div class="left">
            <div class="block">
            <el-cascader
            placeholder="请选择省市"
            :options="provinceOptions"
            @change="searchClick"
            filterable>
            </el-cascader>
        </div>
         <div class="block">
            <el-cascader
            placeholder="请选择城市"
            :options="cityOptions"
             @change="searchClick"
            filterable>
            </el-cascader>
        </div>
         <div class="block">
            <el-cascader
            placeholder="请选择区县"
            :options="countyOptions"
             @change="searchClick"
            filterable>
            </el-cascader>
        </div>
        <div class="block">
            <el-cascader
            placeholder="请选择小区"
            :options="neighbourhoodOptions"
             @change="searchClick"
            filterable>
            </el-cascader>
        </div>
        </div>


        <div class="right">
             <!-- 我要包小区 -->
        <div class="baoXiaoQu">
             <span>我要包小区</span>
        </div>

        <div class="xiaoQuImg">
           <img src="../assets/icon_buy_n.png" alt="">     
           
        </div>

        <!-- 负责人 -->
        <div class="fuZeRen" @click="changeNow">
            <span>找到每个小区的负责人</span>
        </div>

         <!-- 动画搜索框 -->
        <div class="searBox">
            <div class="imgBox" :style="{color:searchBtn != '包小区'?'#fff':''}" @click="changeNow">
                <img class="searchImg1" :style="{display:searchBtn != '包小区'?'none':''}" src="../assets/icon_search.png" alt="">
            </div>
            <div class="inputBox" :class="[searchBtn != '包小区'?'inputBian':'inputDef']">
                <div class="searchImg2Box">
                    <img class="searchImg2" src="../assets/icon_search.png" alt="" @click="imgClick">
                </div>
                 <!-- <input :class="[searchBtn != '包小区'?'inputBian':'inputDef']" type="text"> -->
                <input v-model="fzrName" 
                placeholder='请输入负责人姓名：'
                @keydown.enter='enterSearch'
                type="text">
                <img src="../assets/searchclose.png" alt="" class='clearClick' @click='clearClick'>
            </div>
        </div>
        </div>
        
 </div>



        <div class="down">
            <div class="findBox">
                <span></span>
                <span>小区查找结果</span>
            </div>
            <div class="exhibitionBox">
                <div class="xiaoQuBox" v-for="item in xiaoQuList2">
                <div class="xiaoQuImg">
                    <!-- <img src="../assets/xiaoqu.png" alt="" @click="imgClick"> -->
                    <img :src="item.xiaoQuImg" @click="xiaoQuImgClick(item.xiaoQuName)" alt="">
                </div>

                <div class="xiaoQuName">
                    <p>{{item.xiaoQuName}}</p>
                </div>

                <div class="xiaoQuAddress">
                    <img src="../assets/icon_address.png" alt="">
                    <span>{{item.xaioQuAddress}}</span>
                </div>
                </div>

            </div>
        </div>

        <div>
            <div class='factoryList'>
                 <!-- <factory v-for='(item,index) in factory' :info='item' :key="index"></factory> -->
                <div class="factoryListNext" style="text-align: right;">
                <el-button plain :disabled='disabledReduce' @click='changePageReduce'>上一页</el-button>
                <el-button plain :disabled='disabledPlus' @click='changePagePlus'>下一页</el-button>
                </div>
            </div>
        </div>
       
    </div>
</template>
<script>
export default {
    components:{

    },
    props:['now'],
    data(){
        return {
            nowId:'',
            btnShow: true,
            searchBtn: '',//保存now值，不能直接修改props传输值，会报warn
            fzrName: '',
             page: 1, //分页
             totalPage: 1, //总页数
             pageNumber:15,
             disabledReduce:false,
             disabledPlus:false,
            /* 地区搜索假数据 */
            provinceOptions: [
                {value: 'sichuan',label: '四川'},
                {value: 'anhui',label: '安徽'},
                {value: 'beijing',label: '北京'},],
            cityOptions: [
                {value: 'ankang',label: '安康'},
                {value: 'anshun',label: '安顺'},
                {value: 'anyang',label: '安阳'}],
            countyOptions: [
                {value: 'baoding',label: '保定'},
                {value: 'baoshan',label: '保山'},
                {value: 'baoji',label: '宝鸡'}],
            neighbourhoodOptions: [
                {value: 'yulan',label: '玉兰花园'},
                {value: 'meigui',label: '玫瑰花园'},
                {value: 'yueji',label: '月季花园'}],

            /* 小区假数据  */
            xiaoQuList2: [

            ],
            xiaoQuList: [
                {
                    xiaoQuImg: require('../assets/xiaoqu.png'),
                    xiaoQuName: '小区名字有点长',
                    xaioQuAddress: '成都市青羊区蜀汉路12号'
                },
                 {
                      xiaoQuImg: require('../assets/xiaoqu.png'),
                    xiaoQuName: '小区名字有点长',
                    xaioQuAddress: '成都市青羊区蜀汉路12号'
                },
                 {
                     xiaoQuImg: require('../assets/xiaoqu.png'),
                    xiaoQuName: '小区名字有点长',
                    xaioQuAddress: '成都市青羊区蜀汉路12号'
                },
                 {
                     xiaoQuImg: require('../assets/xiaoqu.png'),
                    xiaoQuName: '小区名字有点长',
                    xaioQuAddress: '成都市青羊区蜀汉路12号'
                },
                 {
                      xiaoQuImg: require('../assets/xiaoqu.png'),
                    xiaoQuName: '小区名字有点长',
                    xaioQuAddress: '成都市青羊区蜀汉路12号'
                },
                 {
                      xiaoQuImg: require('../assets/xiaoqu.png'),
                    xiaoQuName: '小区名字有点长',
                    xaioQuAddress: '成都市青羊区蜀汉路12号'
                },
                 {
                      xiaoQuImg: require('../assets/xiaoqu.png'),
                    xiaoQuName: '小区名字有点长',
                    xaioQuAddress: '成都市青羊区蜀汉路12号'
                },
                 {
                      xiaoQuImg: require('../assets/xiaoqu.png'),
                    xiaoQuName: '小区名字有点长',
                    xaioQuAddress: '成都市青羊区蜀汉路12号'
                },
                {
                    xiaoQuImg: require('../assets/xiaoqu.png'),
                    xiaoQuName: '小区名字有点长',
                    xaioQuAddress: '成都市青羊区蜀汉路12号'
                },
                 {
                    xiaoQuImg: require('../assets/xiaoqu.png'),
                    xiaoQuName: '小区名字有点长',
                    xaioQuAddress: '成都市青羊区蜀汉路12号'
                },
                 {
                      xiaoQuImg: require('../assets/xiaoqu.png'),
                    xiaoQuName: '小区名字有点长',
                    xaioQuAddress: '成都市青羊区蜀汉路12号'
                },
                 {
                     xiaoQuImg: require('../assets/xiaoqu.png'),
                    xiaoQuName: '小区名字有点长',
                    xaioQuAddress: '成都市青羊区蜀汉路12号'
                },
                 {
                     xiaoQuImg: require('../assets/xiaoqu.png'),
                    xiaoQuName: '小区名字有点长',
                    xaioQuAddress: '成都市青羊区蜀汉路12号'
                },
                 {
                      xiaoQuImg: require('../assets/xiaoqu.png'),
                    xiaoQuName: '小区名字有点长',
                    xaioQuAddress: '成都市青羊区蜀汉路12号'
                },
                 {
                      xiaoQuImg: require('../assets/xiaoqu.png'),
                    xiaoQuName: '小区名字有点长',
                    xaioQuAddress: '成都市青羊区蜀汉路12号'
                },
                 {
                      xiaoQuImg: require('../assets/xiaoqu.png'),
                    xiaoQuName: '小区名字有点长',
                    xaioQuAddress: '成都市青羊区蜀汉路12号'
                },
                 {
                      xiaoQuImg: require('../assets/xiaoqu.png'),
                    xiaoQuName: '小区名字有点长',
                    xaioQuAddress: '成都市青羊区蜀汉路12号'
                },
                {
                    xiaoQuImg: require('../assets/xiaoqu.png'),
                    xiaoQuName: '小区名字有点长',
                    xaioQuAddress: '成都市青羊区蜀汉路12号'
                },
            ],
            
        }
    },
    computed: {
        
    },
    mounted: async function(){
        let that = this;
        that.searchBtn = this.now

        let number = that.xiaoQuList.length
/* ****************************************************** */
        that.totalPage = Math.ceil(number/15) 
        console.log(that.totalPage)

      

       for(let i in that.xiaoQuList){
           if(i<=14){
               that.xiaoQuList2.push(that.xiaoQuList[i])
           }
           
       }
       
            
    },
    methods: {
        
        /* 地区搜索点击事件 */
        searchClick(value){
            console.log(value[0])
        },
      
        /* 回车搜索负责人 */
        enterSearch(e) {
           console.log(e)
           this.$message('开发中')
        },

        /* 搜索负责人 图片点击事件 */
        imgClick(){
            let that = this
            let name = that.fzrName
            if(name){
                that.$message('开发中')
            }else{
                that.$message('请输入负责人姓名')
            }
            
        },
        /* 搜索框 清空事件 */
        clearClick(){
            this.fzrName=''
        },
        xiaoQuImgClick(item){
            this.$emit('checkViewShow')
          
        },
        /* 分页 点击事件*/
        /* changePage(e) {
            console.log(e)
            let that = this
            let add = parseInt(e.currentTarget.dataset.add)
            that.page += add
           
            that.search()
      }, */

      changePageReduce(){
          let that = this
          if(that.page!=1){
              
              that.page--
             that.disabledPlus=false;
              
              that.xiaoQuList2.splice(0, that.xiaoQuList2.length);
               for(let i in that.xiaoQuList){
                if(i<15){
                    /* console.log(that.xiaoQuList[i]) */
                    /* console.log(that.xiaoQuList2) */
                    that.xiaoQuList2.push(that.xiaoQuList[i])
                }
            }
          }else{
              that.disabledReduce=true
          }
      },
      changePagePlus(){
          let that = this
          if(that.page!=that.totalPage){
              that.page++
            that.disabledReduce=false
            that.xiaoQuList2.splice(0, that.xiaoQuList2.length);
            for(let i in that.xiaoQuList){
                if(i>14){
                    /* console.log(that.xiaoQuList[i]) */
                   /*  console.log(that.xiaoQuList2) */
                    that.xiaoQuList2.push(that.xiaoQuList[i])
                }
            }
          }else{
               that.disabledPlus=true
          }
      },



      /* 分页 */
      search(){
          let that = this
          /* 请求 */
        //   that.$post('',{},res => {

        //   })

          /* 假数据 */
         
          let number = that.xiaoQuList.length

          that.totalPage = Math.ceil(number/15) 
      },


        getId(id){
            this.nowId = id
            this.$emit('getId',this.nowId)
        },
        changeNow(){
            this.searchBtn = ''
        }
    }
}
</script>